






















import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import { Widget } from '../base/'

import StatusCompactTile from './StatusCompactTile.vue'
import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    StatusCompactTile,
    NoWidgetAccess
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    },
    isEditable: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([ 'getMonitorStatusData']),
    wbuuid() {
      return this.widget.wbUUID
    },
    showTotalAvailability() {
      return this.widget?.customSettings?.settings.showTotalAvailability.checked
    },
    showStatusNames() {
      return this.widget?.customSettings?.settings.showStatusNames.checked
    },
    sortingListStatus() {
      return this.widget?.customSettings?.settings.sortStatus.data.sortedStatus || []
    },
    sortingListQualifications() {
      return this.widget?.customSettings?.settings.sortQualifications.data.sortedQualification || []
    },
    statusData() {
      return this.getMonitorStatusData(this.sortingListStatus, this.sortingListQualifications)
    },
    qualificationsAvailable() {
      const monitor = this.$store.state.monitor[1]
      let hasQualification = false;

      // Reliable and fastes way to access unknown first element ob object
      for (const key in monitor) {
        hasQualification = Object.keys(monitor[key].qualification).length > 0
        break
      }

      return hasQualification
    },
    fontSizes() {
      return {
        'statusNames': this.widget?.customSettings?.settings.fontSizeStatusNames.value,
        'totalAvailability': this.widget?.customSettings?.settings.fontSizeTotalAvailability.value,
        'qualificationsShortname': this.widget?.customSettings?.settings.fontSizeQualificationsShortname.value,
        'qualificationsCount': this.widget?.customSettings?.settings.fontSizeQualificationsCount.value,
      }
    }
  },
})
